import { useEffect } from 'react'

import {
  useGetIntermediateLoginTokenMutation,
  useLogoutMutation
} from 'shared/api/auth/requests'
import { User } from 'shared/types/user'

export const useRedirectClassicUser = (user: User | null) => {
  const logoutMutation = useLogoutMutation()
  const { mutate } = useGetIntermediateLoginTokenMutation({
    onSuccess: data => {
      const url = new URL(process.env.REACT_APP_CLASSIC_CLUSTERIX_DOMAIN!)
      url.pathname = '/login-via-intermediate-token'
      url.searchParams.set('token', data.intermediate_login_token)
      window.location.href = url.toString()
    },
    onError: () => {
      if (!user) return
      logoutMutation.mutate({
        refresh_token: user.refresh_token
      })
    }
  })

  useEffect(() => {
    if (
      !user ||
      !process.env.REACT_APP_CLASSIC_CLUSTERIX_DOMAIN ||
      !user.classic ||
      user.user_roles?.includes('anonymous')
    ) {
      return
    }
    mutate({
      email: user.email
    })
  }, [user, mutate])
}
